import React,{Fragment} from 'react';
import {connect} from 'react-redux';
import DrawerActions from './DrawerActions';



const DrawerTitle = (props) => {
    return(
        <div className="drawerTitle">
                <Fragment>
                    <div className="drawerFix" onClick={()=>{props.toggleDrawerFix()}}>
                        {props.isDrawerFix? <i className="far fa-bring-forward activated"></i> :<i className="fad fa-bring-forward"></i>}
                    </div>
                    {/* <div className="drawerPin" onClick={()=>{props.toggleDrawerPin()}}>
                        {props.isDrawerPin? <i className="fas fa-thumbtack activated"></i> : <i className="fas fa-thumbtack"></i>}
                    </div> */}
                    <span>{props.title}</span>
                    <i className={`backBtn fad ${props.icon? 'fa-'+props.icon: 'fa-angle-right'}`} aria-hidden="true" onClick={props.onClose}></i>
                </Fragment>
        </div>
    )
}
const mapStateToProps = state =>{
    return { 
        isDrawerOpen: state.handleDrawer.isDrawerOpen,
        isDrawerFix: state.handleDrawer.isDrawerFix,
        isDrawerPin: state.handleDrawer.isDrawerPin,
    }
}

export default connect(mapStateToProps,DrawerActions)(DrawerTitle)